import firebase from "firebase/app";
import { IWorkScheduleDoc, IScheduleDay } from "../doc/IWorkScheduleDoc";
import {WorkScheduleFormValues} from "../form/WorkScheduleFormValues";


export function setWorkScheduleParam(form: WorkScheduleFormValues): IWorkScheduleDoc {
  const schedule: IScheduleDay[] = form.days.map((day, index) => {
    const isWorkingDay = !!(day.startTime && day.endTime);

    return {
      day: getDayNameByIndex(index),
      isWorkingDay,
      startTime: isWorkingDay ? day.startTime : null,
      endTime: isWorkingDay ? day.endTime : null,
    };
  });

  return {
    schedule,
    restrictOutsideWorkHours: form.restrictOutsideWorkHours,
    createdAt: firebase.firestore.Timestamp.now(),
  };
}

function getDayNameByIndex(index: number): string {
  const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
  return days[index];
}